import {Component, ElementRef, HostListener, OnInit, Renderer2, ViewChild, Input} from '@angular/core';
import {Router} from '@angular/router';
import {AuthServerProvider} from '../common.module/auth/auth-jwt.service';
import {UserAuth} from '../common.module/auth/user-auth.model';
import {NotificationsResource} from './service/notifications.resource';
import {NotificationModel} from './service/notification.model';
import {EventBusService} from '../common.module/util/event-bus.service';
import {ModalDirective, ToastService} from 'ng-uikit-pro-standard';
import {ConfiguracionGeneralModel} from '../admin.configuracion-general.module/service/configuracion-general.model';
import {DataSessionShareService} from '../common.module/util/data-share-session.service';
import {AuthExtendedResource} from '../main-login.component/service/auth-extended.resource';
import {CategoriasService} from '../admin.categorias.module/service/categorias.service';
import {TramitesService} from '../admin.tramites.module/service/tramites.service';
import {FormalitiesResource} from './service/formalities.resource';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit {
  @ViewChild('infoModal')
  public infoModal: ModalDirective;
  @ViewChild('dropdown')
  public notificaciones: any;
  public resultadoBusqueda: any = [];
  public showBusqueda = false;
  public searchStr: { s: any } = {
    s: ''
  };
  @Input() configuracion: ConfiguracionGeneralModel = {};
  public notifications: NotificationModel[] = [];
  public showNotifications = false;
  public disLogoPrincipal = 'tipo-1';
  public user: UserAuth;
  public categoriasHead: any = [{tramites: []}];


  public menu: any = [];
  private porPaginaR = 3;
  private porPaginaT = 4;
  public verBusqueda = true;
  public verMenuMovil = false;
  public tramitesMM: any = [];
  public tipoCategoriaMM: any = [];
  public sinTramites = 'Cargando trámites';
  private tramitesMenu: any = [];
  private tipos: any = [];
  public mensajeNoBusqueda: String = "No se han encontrado coincidencias en la búsqueda.";

  constructor(
    private toastMsg: ToastService,
    private authServerProvider: AuthServerProvider,
    private router: Router,
    private notificationsResource: NotificationsResource,
    private categoriasService: CategoriasService,
    private tramitesService: TramitesService,
    protected dataShare: DataSessionShareService,
    private authResource: AuthExtendedResource,
    private eb: EventBusService,
    private renderer: Renderer2,
    private el: ElementRef,
    private formalitiesResource: FormalitiesResource) {

    this.dataShare.objectConfirmed$.subscribe(usr => {
      console.log('Algo llegó al body del header :P');
      console.log(usr);
      if (usr && usr.discriminator == 'sessionUser') {
        this.setUserSession(usr);
        console.log('Se inicio sesíon desde el header');
      }
    });
  }

  ngOnInit(): void {
    this.user = this.authServerProvider.getUserDecoded();
    this.loadNotifications();
    this.loadConnectionNotifications();
    this.loadCategorias();
  }

  ngOnChanges(): void {
    //this.configuracion = JSON.parse(localStorage.getItem('configuracionGeneral'));
    this.menu = [
      {
        nombre: 'TIA',
        tiposCategoria: [
          {
            nombre: 'Tarjeta de identificación aeroportuaria',
            categorias: [
              {
                nombre: 'Solicitud',
                estatus: false,
                archivo: '',
                tramites: []
              },
              {
                nombre: 'Reposición',
                estatus: false,
                archivo: '',
                tramites: []
              },
              {
                nombre: 'Renovación',
                estatus: false,
                archivo: '',
                tramites: []
              }
            ]
          }
        ]
      },
      {
        nombre: 'TPV',
        tiposCategoria: [
          {
            nombre: 'Tarjetón de pensión vehícular',
            categorias: [
              {
                nombre: 'Solicitud',
                estatus: false,
                archivo: '',
                tramites: []
              },
              {
                nombre: 'Reposición',
                estatus: false,
                archivo: '',
                tramites: []
              },
              {
                nombre: 'Renovación',
                estatus: false,
                archivo: '',
                tramites: []
              }
            ]
          }
        ]
      },
      {
        nombre: 'AV',
        tiposCategoria: [
          {
            nombre: 'Acreditación vehícular',
            categorias: [
              {
                nombre: 'Solicitud',
                estatus: false,
                archivo: '',
                tramites: []
              },
              {
                nombre: 'Reposición',
                estatus: false,
                archivo: '',
                tramites: []
              },
              {
                nombre: 'Renovación',
                estatus: false,
                archivo: '',
                tramites: []
              }
            ]
          }
        ]
      },
      {
        nombre: 'VISITANTE',
        tiposCategoria: [
          {
            nombre: 'Registro de visitantes',
            categorias: [
              {
                nombre: 'Solicitud',
                estatus: false,
                archivo: '',
                tramites: []
              }
            ]
          }
        ]
      }
    ];
    this.formalitiesResource.obtenerUnaCategoria().then(categorias => {
      let i = 0;
      const len = categorias.length;
      categorias.forEach(categoria => {
        if (!categoria.hasOwnProperty('tipo')) {
          categoria.tipo = 'VISITANTE';
        }
        this.menu.forEach(menu => {
          if (categoria.tipo == menu.nombre) {
            menu.tiposCategoria[0].categorias.forEach(cates => {
              categoria.tramites.forEach(tramite => {
                const catNombre = cates.nombre.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
                const tramiteTipo = tramite.tipo.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
                if (catNombre.toUpperCase() == tramiteTipo.toUpperCase()) {
                  cates.estatus = true;
                  cates._id = categoria._id;
                  cates.tramites.push(tramite);
                }
              });
            });
          }
        });
        i++;
      });
      const watcher = setInterval(() => {
        if (i == len) {
          clearInterval(watcher);
          console.log(this.menu);
          this.getScreenSize();
        }
      }, 500);
    }, err => {
      console.log('error');
      console.log(err);
    });
  }

  mostrarMenuMovil() {
    this.verMenuMovil = !this.verMenuMovil;
  }

  getMenuWithCheckScreen() {
    this.verBusqueda = true;
    if (window.innerWidth <= 767) {
      this.porPaginaR = 2;
      this.porPaginaT = 2;
      this.verBusqueda = false;
    }
    if (window.innerWidth <= 575) {
      this.porPaginaR = 1;
      this.porPaginaT = 1;
    }
    this.getMenu();
  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.verBusqueda = true;
    if (window.innerWidth <= 767) {
      this.porPaginaT = 2;
      this.verBusqueda = false;
    }
    if (window.innerWidth <= 575) {
      this.porPaginaT = 1;
    }
    this.getMenu();
  }

  getMenu() {
    for (let i = 0; i < this.menu.length; i++) {
      this.menu[i].active = false;
      for (let a = 0; a < this.menu[i].tiposCategoria.length; a++) {
        for (let e = 0; e < this.menu[i].tiposCategoria[a].categorias.length; e++) {
          this.menu[i].tiposCategoria[a].categorias[e].index = i;
          this.tramitesMenu.push(this.menu[i].tiposCategoria[a].categorias[e]);
          this.menu[i].tiposCategoria[a].categorias[e].active = (e == 0) ? true : false;
          for (let t = 0; t < this.menu[i].tiposCategoria[a].categorias[e].tramites.length; t++) {
            this.menu[i].tiposCategoria[a].categorias[e].tramites[t]['active'] = false;
          }
        }
      }
      const cat = this.menu[i].tiposCategoria[0].categorias[0];
      this.verTramites(i, cat._id, cat.nombre, true);
    }
  }

  verTramites(index, id, nombre, primero): void {
    this.tramitesMM[index] = [];
    this.sinTramites = 'Cargando trámites';
    const iteracion1 = this.menu[index].tiposCategoria.length;
    for (let a = 0; a < iteracion1; a++) {
      const iteracion2 = this.menu[index].tiposCategoria[a].categorias.length;
      for (let e = 0; e < iteracion2; e++) {
        if (primero) {
          this.menu[index].tiposCategoria[a].categorias[0].active = true;
        } else {
          this.menu[index].tiposCategoria[a].categorias[e].active = true;
          if (nombre != this.menu[index].tiposCategoria[a].categorias[e].nombre) {
            this.menu[index].tiposCategoria[a].categorias[e].active = false;
          }
        }
      }
    }
    let results;
    for (let i = 0; i < this.tramitesMenu.length; i++) {
      const categoria = this.tramitesMenu[i];
      if (categoria.index === index && categoria.nombre === nombre) {
        results = categoria;
        break;
      } else {
        results = [];
      }
    }
    if (results != []) {
      let res = [];
      res = (results.tramites) ? results.tramites : [];
      if (res.length < 1) {
        this.sinTramites = 'No hay trámites configurados';
      }

      const operacion1 = (res.length / this.porPaginaT);
      const total = res.length;
      this.tramitesMM[index] = [];
      this.tramitesMM[index]['sliders'] = [];
      let inicio;
      let fin;
      for (let i = 0; i < operacion1; i++) {
        if (total < this.porPaginaT) {
          const trams = {
            tramites: res
          };
          this.tramitesMM[index]['sliders'].push(trams);
        } else {
          if (i <= 0) {
            inicio = i;
            fin = this.porPaginaT;
          } else {
            inicio = (this.porPaginaT * i);
            fin = inicio + this.porPaginaT;
          }

          const bloque = res.slice(inicio, fin);
          const trams1 = {
            tramites: bloque
          };
          this.tramitesMM[index]['sliders'].push(trams1);
        }
      }
    }
  }

  remStyle(e) {
    const hijo = e.target.nextElementSibling;
    hijo.removeAttribute('style');
  }

  verMenu(e, index) {
    this.ocultarMenu();
    const hijo = e.target.nextElementSibling;
    hijo.setAttribute('style', 'display:block;');
    let i = 0;
    this.menu.forEach(itm => {
      itm.active = false;
      if (i == index) {
        itm.active = true;
      }
      i++;
    });
  }

  detalleTramite(tramiteId: string) {
    this.router.navigate(['portal/detail/'], {queryParams: {tramite: tramiteId}});
    this.ocultarMenu();
    this.verMenuMovil = false;
  }

  hideNav(e) {
    e.hide();
  }

  checkDropdownMM(e) {
    e.stopPropagation();
  }

  ocultarMenu() {
    console.log('mouser over ocultar menu');
    const dropdownMenu = Array.from(this.el.nativeElement.querySelectorAll('.menu-mega-head'));
    dropdownMenu.forEach(dropdown => {
      this.renderer.setStyle(dropdown, 'display', 'none');
    });
  }

  categoriasHeader() {
    this.categoriasService.lodCategoriasBusqueda({s: ''}).then(cat => {
      const last = cat.length;
      for (let i = 0; i < last; i++) {
        this.categoriasService.lodCategoriaPublic({categoria_id: cat[i]['_id']}).then(re => {
          this.categoriasHead[i] = re;
          this.categoriasHead[i]['solicitudL'] = 0;
          this.categoriasHead[i]['reposicionL'] = 0;
          this.categoriasHead[i]['renovacionL'] = 0;
          const tramites = this.categoriasHead[i]['tramites'];
          tramites.forEach(item => {
            item.tipo == 'Solicitud' ? this.categoriasHead[i]['solicitudL']++ : this.nada();
            (item.tipo.toUpperCase() == "Renovación".toUpperCase() || item.tipo.toUpperCase() == "Renovacion".toUpperCase()) ? this.categoriasHead[i]['renovacionL']++ : this.nada();
            (item.tipo.toUpperCase() == "Reposición".toUpperCase() || item.tipo.toUpperCase() == "Reposicion".toUpperCase()) ? this.categoriasHead[i]['reposicionL']++ : this.nada();
          });
          if (i > 0 && i < last) {
            this.categoriasHead[i]['separador'] = 'separador-items';
          } else {
            this.categoriasHead[i]['separador'] = '';
          }
        });
      }
    }, err => {
      console.log('error con las categorias...');
    });
  }

  nombreClase(): string {
    return 'separador-items';
  }

  nada(): void {
    return null;
  }

  loadConnectionNotifications() {
    if (this.user)
      this.eb.registerHandler('ms.notifications.user.' + this.user._id, (error, message) => {
        if (error) {
          console.error('AppEventBusService.handleAction error', error);
          return;
        }
        if (!message.body) {
          console.error('AppEventBusService.handleAction - body is required in message', message);
          return;
        }
        this.toastMsg.info(message.body.titulo);
        this.loadNotifications();
      });
  }

  hideList() {
    setTimeout(res => {
      this.showBusqueda = false;
    }, 500);
  }

  showList() {
    setTimeout(res => {
      this.showBusqueda = true;
    }, 500);
  }

  loadCategorias() {
    this.resultadoBusqueda = [];
    this.mensajeNoBusqueda = 'Buscando...';
    if (this.searchStr.s.length < 1) {
      this.categoriasService.lodCategoriasBusqueda(this.searchStr).then(cate => {
        if (cate.length < 1)
          this.mensajeNoBusqueda = 'No se han encontrado coincidencias en la búsqueda.';
        this.resultadoBusqueda = cate;
      }, err => {
        this.toastMsg.error('Error al obtener datos de la búsqueda');
      });
    } else {
      this.loadTramites();
    }
  }

  loadTramites() {
    this.resultadoBusqueda = [];
    this.mensajeNoBusqueda = 'Buscando...';

    const stackPromise: Promise<any>[] = [];
    stackPromise.push(this.categoriasService.lodCategoriasBusqueda(this.searchStr));
    stackPromise.push(this.tramitesService.obtenerTramitesPublic(this.searchStr));

    if (this.searchStr.s.length > 0) {
      Promise.all(stackPromise).then(bus => {
        if (bus[0].length < 1 && bus[1].length < 1)
          this.mensajeNoBusqueda = 'No se han encontrado coincidencias en la búsqueda.';
        const resultado = bus[0].concat(bus[1]);
        this.resultadoBusqueda = resultado;
        console.log(this.resultadoBusqueda);
      });
    } else {
      this.loadCategorias();
    }
  }

  detalle(tramiteId: string) {
    this.router.navigate(['portal/detail/'], {queryParams: {tramite: tramiteId}});
  }

  detalleCategoria(categoriaId: string) {
    this.router.navigate(['portal/detail/'], {queryParams: {categoria: categoriaId}});
  }

  click(detail: string, id: number, event: any) {
    event.target.classList.add('hover-click');
    event.target.classList.remove('hover-image');
    setTimeout(() => {
      if (id !== 0) {
        event.target.classList.add('d-none');
        this.router.navigate(['portal', detail], {queryParams: {categoria: id}});
      }
      if (id === 0) {
        event.target.classList.add('d-none');
        this.router.navigate(['portal', detail]);
      }
    }, 500);
    console.log(event);
  }

  logout() {
    this.authResource.logout().then(aVoid => {
      console.log('Cerrado de sesión guardado en bitácora');
    }, err => console.error(err));
    this.authServerProvider.logout();
    this.toastMsg.info('Hemos cerrado la sesión.');
    this.user = {discriminator: 'closeSession'};
    this.dataShare.confirmObject(this.user);
    delete this.user;
    this.router.navigate(['/portal']);
  }

  setUserSession(usr: UserAuth) {
    if (this.user == null) {
      this.user = usr;
      this.user.discriminator = 'sessionUser';
      this.dataShare.confirmObject(this.user);
      this.loadConnectionNotifications();
      this.loadNotifications();
    }
    // this.user = usr;
    // this.loadConnectionNotifications();
    // this.loadNotifications();
  }

  loadNotifications() {
    if (this.user)
      this.notificationsResource.getNewNotifications({s: 1}).then(res => {
        this.notifications = res;
        console.log(res);
        this.notifications.sort(function(a, b) {
          return a._id - b._id;
        }).reverse();
      }, err => console.error(err));
  }

  seenNotification(notification: NotificationModel, navegar: boolean = false) {
    if (notification && !notification.fecha_visto)
      this.notificationsResource.seenNotifications({_id: notification._id}).then(obj => {
        const index = this.notifications.findIndex(el => el._id === notification._id);
        if (index != -1) {
          this.notifications.splice(index, 1);
          this.notificaciones.show();
        }
      });
    if (navegar && notification.app_path)
      this.router.navigate(['/portal' + notification.app_path]);
  }
}
